define('home/views/SettingsConnectedAccountsView',[
    'jquery',
    'backbone-marionette',
    'underscore',

    'core/config',
    'core/engagement/page',
    'core/strings',
    'core/utils',

    'home/models/Session',
    'home/models/SettingsSocialAccount',
    'home/templates/settingsConnectedAccounts',
], function (
    $,
    Marionette,
    _,

    config,
    pageEngagement,
    strings,
    utils,

    Session,
    SettingsSocialAccount,
    settingsConnectedAccountsTemplate
) {
    'use strict';

    var gettext = strings.get;

    var SettingsConnectedAccountsView = Marionette.ItemView.extend({

        template: settingsConnectedAccountsTemplate,

        events: {
            'click [data-action=connect]': 'connectHandler',
            'click [data-action=disconnect]': 'disconnectHandler',
        },

        initialize: function () {
            this.listenTo(this.collection, 'reset remove add', this.render);
            this.session = Session.get();
        },

        disconnectHandler: function (ev) {
            ev.preventDefault();

            var $btn = $(ev.originalEvent.target);
            var service = $btn.attr('data-social');
            var socialAccount = this.collection.get(service);
            var self = this;
            socialAccount
                .destroy({ wait: true })
                .fail(_.bind(self.showDisconnectError, self))
                .done(function (response) {
                    // Since this endpoint returns a 200 regardless of whether removing
                    // the social account was destroyed or not, we have to explicitly check
                    // for success here and manually add the model back into the collection
                    // if it wasn't successful
                    if (!response.success) {
                        this.collection.add(socialAccount);
                        self.showDisconnectError();
                    }
                });
        },

        showDisconnectError: function () {
            this.updateSocialStatus(gettext('Can\'t disconnect your account.'));
        },

        connectHandler: function (ev) {
            ev.preventDefault();

            var $btn = $(ev.originalEvent.target);
            var service = $btn.attr('data-social');
            this.authenticate(service);
        },

        authenticate: function (service) {
            var authWindow = this.openAuthWindow(service);

            if (utils.isMobileUserAgent())
                this.checkStatusOnPageVisible(service);
            else
                this.pollAuthWindow(service, authWindow);

        },

        openAuthWindow: function (service) {
            var params = 'location=0,status=0,width=800,height=400';
            var url = this.getConnectUrl(service);
            return window.open(url, service + 'Window', params);
        },

        getConnectUrl: function (service) {
            return config.urls.oauth[service] + '?ctkn=' + this.session.getCsrfToken();
        },

        pollAuthWindow: function (service, authWindow) {
            var self = this;
            var pollInterval = setInterval(function () {
                if (!authWindow.closed)
                    return;

                clearInterval(pollInterval);
                self.getAuthenticationStatus(service);
            }, 1000);
        },

        /**
         * On mobile browsers, the social auth tab either doesn't close or we can't check
         * if an open web view is closed on non native browsers. So we use Page
         * Visibility to check if this window comes back into focus and then force a
         * check of social auth status.
         */
        checkStatusOnPageVisible: function (service) {
            var self = this;
            var checkAuthStatus = function (isEngaged) {
                if (!isEngaged)
                    return;

                self.getAuthenticationStatus(service);
                pageEngagement.off('change:isEngaged', checkAuthStatus);
            };
            pageEngagement.on('change:isEngaged', checkAuthStatus);
        },

        getAuthenticationStatus: function (service) {
            var self = this;
            var socialAccount = new SettingsSocialAccount({
                id: service,
            });
            socialAccount
                .fetch()
                .fail(_.bind(self.showConnectError, self))
                .done(function (response) {
                    if (response.success)
                        self.collection.add(socialAccount);
                    else
                        self.showConnectError();
                });
        },

        showConnectError: function () {
            this.updateSocialStatus(gettext('Can\'t connect to your account.'));
        },

        updateSocialStatus: function (msg) {
            this.$('[data-role=connected-accounts-alert]').text(msg);
        },
    });

    return SettingsConnectedAccountsView;
});


